import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { changeStatusVisit, deleteVisit, getVisits, sendPaymentMail } from "../../../../api/visit";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
	buttonsStyle,
	dateFormatter,
} from "../../../components/tables/table";
import MyAutocomplete from "../../../components/MyAutocomplete";
import { getPatients } from "../../../../api/user";
import { Payment } from "@material-ui/icons";

function sortByDate(a, b) {
	if (a.visitDate > b.visitDate) return -1;
	if (a.visitDate < b.visitDate) return 1;
	return 0;
}

function getData(visits) {
	let data = [];
	for (let i = 0; i < visits.length; ++i) {
		const visit = visits[i];
		const elem = {};
		elem.visitDate = visit.visitDate;
		elem.visitType = getNonEmpty(visit.visitType?.fullName);
		elem.visitState = visit?.visitState;
		elem.patient = visit.user?.name+' '+visit.user?.surname;
		elem.createdAt = visit.createdAt;
		elem.id = visit._id;
		elem.active = visit.active;
		elem.cancelURL = visit?.cancelURL || "";
		data = data.concat(elem);
	}

	data.sort(sortByDate);

	return data;
}

export default function VisitsPage() {
	const [data, setData] = useState([]);
	const [visitId, setVisitId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [allUsers, setAllUsers] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null);
	const [openDialog, setOpenDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item._id === cell);
		return (
			<>
				{ elem.active && elem.visitState !== "Pagada" && (
					<Tooltip title="Payment mail">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => {
								setOpenConfirmDialog(3);
								setVisitId(elem);
							}}
						>
							<Payment />
						</Button>
					</Tooltip>
				)}
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push("/edit-visit/" + cell)}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes("admin") && (
					<>
						<Tooltip title={elem?.active ? "Disable" : "Enable"}>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setVisitId(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.active ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "#00F" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Delete">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									if (elem.active && elem?.cancelURL) {
										// const url = elem.cancelURL ? elem.cancelURL : "https://calendly.com/app/scheduled_events/user/me";
										window.open(elem.cancelURL, '_blank');
									}
									else {
										setVisitId(cell);
										setOpenConfirmDialog(2);
									}
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{
			dataField: "patient",
			text: "Patient",
			sort: true,
			headerAlign: "left",
			align: "left",
		},
		{
			dataField: "visitDate",
			text: "Date",
			formatter: dateFormatter,
			sort: true,
			headerAlign: "left",
			headerStyle: { width: '175px' },
			align: "left",
		},
		{
			dataField: "visitType",
			text: "Visit Type",
			sort: true,
			headerStyle: { width: '175px' },
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "visitState",
			text: "Visit State",
			sort: true,
			headerStyle: { width: '175px' },
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "createdAt",
			text: "Created at",
			headerAlign: "center",
			align: "center",
			headerStyle: { width: '175px' },
			formatter: dateFormatter,
			sort: true,
		},
		{ 
			dataField: "id", 
			text: "", 
			headerStyle: { width: '200px' },
			formatter: buttonFormatter ,
			align: 'right',
			headerAlign: 'right',
		},
	];

	useEffect(() => {
		getVisits()
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get visits.",
				});
			});
	}, [refresh]);

	useEffect(() => {
		getPatients()
			.then((res) => {
				setAllUsers(res.data);
			})
			.catch((error) => {
				alertError({ error, customMessage: "Could not find users." });
			})
	}, [])

	const ModalSelectorCalendly = () => {
		return (
			<Dialog disableBackdropClick={true}
				fullWidth={true}
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				maxWidth="lg"
				aria-labelledby="table-dialog"
			>
				<DialogTitle id="table-dialog">{"Add new visit in Calendly"}</DialogTitle>
				<DialogContent>
					<MyAutocomplete 
						options={ allUsers }
						getOptionLabel={(option) =>
							`${option.name} ${option.surname}`
						}
						value={selectedUser}
						onChange={(event, selected) => {
							setSelectedUser(selected);
						}}
						placeholder="Select user"
						label={"User"}
					/>
					<br /><br /><br /><br /><br /><br />
					<br /><br /><br /><br /><br /><br /><br />
				</DialogContent>
				<DialogActions>
					<Button
						variant="outlined"
						style={{ marginRight: "15px" }}
						onClick={() => {
							setOpenDialog(false);
							// setVisit(getEmptyVisit());
						}}
					>
						Close
					</Button>
					<Button
						variant="outlined"
						color="primary"
						style={{ marginRight: "15px" }}
						onClick={() => {
							if (selectedUser) {
								const _user = selectedUser;
								const uri = `/calendly?id=${_user._id}&name=${_user.name}&surname=${_user.surname}&email=${_user.email}`;
								window.open(uri, '_blank');
							}
						}}
					>
						Go to Calendly
					</Button>
				</DialogActions>
			</Dialog>
		)
	}

	return (
		<>
			<Card>
				<CardHeader title="Visits list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-visit")}
						>
							Add new without cost
						</button>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => setOpenDialog(true)}
							style={{ marginLeft: 5 }}
						>
							Add new in calendly
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<ModalSelectorCalendly />
					<Table data={getData(data)} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${
							visitId?.active ? "disable" : "enable"
						} this visit?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusVisit(visitId._id, !visitId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												visitId?.active
													? "Disabled!"
													: "Enabled!"
											}`,
											customMessage: `Visit ${
												visitId?.active
													? "disabled"
													: "enabled"
											} successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `Could not ${
											visitId?.active
												? "disable"
												: "enable"
										} visit.`,
									});
								});
						}}
					/>
					<ConfirmDialog
						title={"Are you sure you want to remove this visit?"}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteVisit(visitId)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Visit removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: "Could not remove visit.",
									});
								});
						}}
					/>
					<ConfirmDialog
						title={
						"Are you sure you want to send the payment mail?"
						}
						open={openConfirmDialog === 3}
						setOpen={setOpenConfirmDialog}
						onConfirm={async () => {
							sendPaymentMail(visitId._id)
								.then((res) => {
									alertSuccess({ title: "Success!", customMessage: "Mail sended correctly."})
								})
								.catch((error) => {
									alertError({error, customMessage: "Could not send Mail."})
								})
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
